/* eslint-disable react-hooks/exhaustive-deps */
import { Stack, Typography } from '@mui/material'
import '../CustomFiltersStyle.scss';
import { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const CustomConditionalFilter = (props) => {
    const { 
        value = {},
        title = "",
        inputRef = null,
        localStorageKey = null,
        dataTestIdKey = null,
        onChange = () => {},
        onClick = () => {},
        onKeyDown = () => {},
        setLocalInputValue = () => {},
        item = {},
        updateFilter = () => {}
     } = props;
    const filterTestIdKey = dataTestIdKey || localStorageKey;
    const [conditionValue, setConditionValue] = useState(value?.condition || 'ls');
    const [inputValue, setInputValue] = useState(value?.value || '');
    const containerRef = useRef(null);

    const onBlurHandler = () => {
        if(inputValue === '')return;
        let numericValue = parseFloat(inputValue);
        if(isNaN(numericValue))return;
        setInputValue(inputValue);
        onChange({
            value: inputValue,
            condition: conditionValue
        });
    }
    useEffect(() => {
        if(inputValue){
            onChange({
                value: inputValue,
                condition: conditionValue
            });
        }
    }, [conditionValue]);

    // if user press enter key and input is not empty, update the filter
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if(inputValue === '')return;
            let numericValue = parseFloat(inputValue);
            if(isNaN(numericValue))return;
            setInputValue(inputValue);
            onChange({
                value: inputValue,
                condition: conditionValue
            });
        }
    };

    // if user click outside and input is empty, reset the filter
    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            if(inputValue === ''){
                 updateFilter(item.id, (item) => {
                    item.isActive = false;
                    item.value = value;
                    return item;
                });
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [inputValue]);


  return (
    <Stack
        direction='row'
        bgcolor={'#2E3452'}
        borderRadius={'999px'}
        justifyContent={'center'}
        alignItems={'center'}
        padding={'0px'}
        gap={'6px'}
        maxWidth={'fit-content'}
        ref={containerRef}
    >
        <Typography 
            color={'#fff'} 
            fontSize={'16px'} 
            fontWeight={500} 
            fontFamily={'Montserrat'}
            data-testid={`active-${filterTestIdKey}-filter`}
        >
                {title}
        </Typography>
        <select 
            className='bytes-conditions-select' 
            onChange={(e) => setConditionValue(e.target.value)} 
            value={conditionValue}
            data-testid={`active-${filterTestIdKey}-filter-condition-select`}
        >
            <option value="ls">{"<="}</option>
            <option value="eq">{"="}</option>
            <option value="gt">{">="}</option>
        </select>
        <input 
            className='bytes-input' 
            onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                    setInputValue("");
                    setLocalInputValue("");
                    return;
                }

                if (item?.id !== "store_rating") {
                    setInputValue(value);
                    setLocalInputValue(value);
                    return;
                }

                const numValue = Number(value);
                const condition = item?.value?.condition;

                if (isNaN(numValue) || numValue < 0) {
                    confirmAlert({
                       title: "Alert",
                       message: "Please enter a valid non-negative number",
                       buttons: [{ label: "OK", onClick: ()=>{return;}}]
                   });
                    setInputValue("0");
                    setLocalInputValue("0");
                    return;
                }

                if (condition === "ls" && (numValue < 1 || numValue > 5)) {
                    confirmAlert({
                        title: "Alert",
                        message: "Store rating must be between 1 and 5",
                        buttons: [{ label: "OK"}]
                    });
                    setInputValue("5");
                    setLocalInputValue("5");
                    return;
                }

                if (condition === "gt" && numValue >= 5) {
                    confirmAlert({
                        title: "Alert",
                        message: "Store rating must be less than 5",
                        buttons: [{ label: "OK" }]
                    });
                    setInputValue("0");
                    setLocalInputValue("0");
                    return;
                }

                if (condition === "eq" && (numValue < 0 || numValue > 5)) {
                    confirmAlert({
                        title: "Alert",
                        message: "Store rating must be between 0 and 5",
                        buttons: [{ label: "OK" }]
                    });
                    setInputValue("0");
                    setLocalInputValue("0");
                    return;
                }

                // otherwise set value
                setInputValue(value);
                setLocalInputValue(value);
            }}
            onBlur={(e)=>{
                e.stopPropagation();
                e.preventDefault();
                const value = e.target.value;
                if (!value || value.trim() === "") return;
                onBlurHandler(e);
            }}
            value={inputValue}
            data-testid={`active-${filterTestIdKey}-filter-input`}
            ref={inputRef}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        />
        {item?.id === "store_rating" && (
            <Typography 
                color={'#fff'} 
                fontSize={'16px'} 
                fontWeight={500} 
                fontFamily={'Montserrat'}
            >
                Star(s)
            </Typography>
        )}
    </Stack>
  )
}

export default CustomConditionalFilter